// @ts-check
/**
 * Single entry point for every admin-created order: pick what kind it is, then the matching
 * form opens. Replaces the old two separate buttons (Record in-person sale / New Gift Order)
 * on the Orders page with one Create Order button.
 */
import { useState } from 'react';
import GiftOrderModal from './GiftOrderModal';
import PosOrderModal from './PosOrderModal';
import Modal from './ui/Modal';

const ORDER_TYPES = [
  {
    value: 'in_person',
    label: 'In-person sale',
    hint: 'A pop-up or event stand sale, tied to that event.',
  },
  {
    value: 'general',
    label: 'General order',
    hint: 'Any other order taken by hand - a phone order, a showroom sale - not tied to an event.',
  },
  {
    value: 'gift',
    label: 'Gift / sample order',
    hint: 'Zero-value stock sent to an influencer or as a sample.',
  },
];

/** @param {{onClose: () => void, onOrderCreated?: (order: any) => void}} props */
const CreateOrderModal = ({ onClose, onOrderCreated }) => {
  const [orderType, setOrderType] = useState(/** @type {string | null} */ (null));

  if (orderType === 'in_person') return <PosOrderModal onClose={onClose} />;
  if (orderType === 'general') return <PosOrderModal onClose={onClose} requireEvent={false} title="Create order" />;
  if (orderType === 'gift') {
    return <GiftOrderModal influencer={null} onClose={onClose} onCreated={onOrderCreated} />;
  }

  return (
    <Modal maxWidth="md" onClose={onClose} hasUnsavedChanges={false}>
      <div className="px-6 py-4 border-b">
        <h2 className="text-lg font-semibold">Create order</h2>
      </div>
      <div className="p-6 space-y-3">
        {ORDER_TYPES.map((type) => (
          <button
            key={type.value}
            onClick={() => setOrderType(type.value)}
            className="w-full text-left px-4 py-3 border border-input rounded-lg hover:bg-muted/50"
          >
            <div className="font-medium">{type.label}</div>
            <div className="text-sm text-muted-foreground">{type.hint}</div>
          </button>
        ))}
      </div>
      <div className="flex items-center gap-3 px-6 py-4 border-t">
        <button onClick={onClose} className="px-4 py-3 text-base border border-input rounded-lg hover:bg-accent">
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default CreateOrderModal;
